import { Component, Input, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { lineaInversionInfo } from 'src/app/home/_models/linea-inversion';
import { isPlatformBrowser } from '@angular/common';
import { UsuarioService } from 'src/app/_services/usuario.service';
import { DOMAIN_ENVIRONMENT } from 'src/app/_services/base.service';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { SelectLineaComponent } from 'src/app/home/lineas-inversion/select-linea/select-linea.component';
import { SelectLineaMobileComponent } from 'src/app/home/lineas-inversion/select-linea-mobile/select-linea-mobile.component';
import { HomeFactoringComponent } from 'src/app/factoring/shared/home/home-factoring.component';
import { HomeFundsComponent } from 'src/app/funds/shared/home/home-funds/home-funds.component';
import { HomeVentureComponent } from 'src/app/venture/shared/home/home-venture.component';
import { HomeRealestateComponent } from 'src/app/realestate/shared/home/home-realestate/home-realestate.component';
import { HomeCreativeComponent } from 'src/app/creative/shared/home/home-creative/home-creative.component';
import { PlatformService } from 'src/app/_services/platform.service';

@Component({
  selector: 'app-lineas-inversion',
  templateUrl: './lineas-inversion.component.html',
  styleUrls: ['./lineas-inversion.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    SelectLineaComponent,
    SelectLineaMobileComponent,
    HomeVentureComponent,
    HomeRealestateComponent,
    HomeFactoringComponent,
    HomeFundsComponent,
    HomeCreativeComponent
  ]
})


export class LineasInversionComponent implements OnInit
{
  @Input() plataformaId: string;
  isLogged: boolean;
  lineaActiva: string;
  componentInfo = new Map<string, lineaInversionInfo>();
  infoLineas: lineaInversionInfo[] = [];
  infoLineaActiva: lineaInversionInfo;
  selectedProducto: 'cnmv' | 'otros';

  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private _usuarioService: UsuarioService,
    private _platformService: PlatformService
  )
  {
  }

  ngOnInit(): void
  {
    this.getSession();
    this.getInfoLineas();
    this.getPlataformaDomain();
    this.fixMobilePosition();
  }

  private getSession()
  {
    this.isLogged = this._usuarioService.getSession() ? true : false;
  }

  private getInfoLineas(): void
  {
    let segoVenturesInfo: lineaInversionInfo = {
      ref: 'venture',
      segoMatIconName: 'moving',
      segoTitulo: 'SEGO Venture',
      segoInvertir: 'Invierte en <span class="font-weight-600">Startups</span>',
      segoBgActive: 'bg-secondary-venture-300',
      pretitulo: 'SEGO <span class="secondary-venture-500">Venture</span>',
      lineaColorActive: 'secondary-venture-500'
    }
    let segoRealEstateInfo: lineaInversionInfo = {
      ref: 'realestate',
      segoMatIconName: 'maps_home_work',
      segoTitulo: 'SEGO Real Estate',
      segoInvertir: 'Invierte en <span class="font-weight-600">Inmobiliario</span>',
      segoBgActive: 'bg-secondary-estate-100',
      pretitulo: 'SEGO <span class="secondary-estate-500">Real Estate</span>',
      lineaColorActive: 'secondary-estate-500'
    }
    let segoCreativeInfo: lineaInversionInfo = {
      ref: 'creative',
      segoMatIconName: 'lightbulb',
      segoTitulo: 'SEGO Creative',
      segoInvertir: 'Invierte en <span class="font-weight-600">Cultura</span>',
      segoBgActive: 'bg-secondary-creative-200',
      pretitulo: 'SEGO <span class="secondary-creative-500">Creative</span>',
      lineaColorActive: 'secondary-creative-500'
    }
    let segoFactoringInfo: lineaInversionInfo = {
      ref: 'factoring',
      segoMatIconName: 'insert_drive_file',
      segoTitulo: 'SEGO Factoring',
      segoInvertir: 'Invierte en <span class="font-weight-600">Factoring</span>',
      segoBgActive: 'bg-secondary-factoring-300',
      pretitulo: 'SEGO <span class="secondary-factoring-500">Factoring',
      lineaColorActive: 'secondary-factoring-500'
    }
    let segoFundsInfo: lineaInversionInfo = {
      ref: 'funds',
      segoMatIconName: 'savings',
      segoTitulo: 'SEGO Funds',
      segoInvertir: 'Invierte en <span class="font-weight-600">Indexados</span>',
      segoBgActive: 'bg-secondary-funds-200',
      pretitulo: 'SEGO <span class="secondary-funds-500">Funds</span>',
      lineaColorActive: 'secondary-funds-500'
    }

    this.componentInfo["segoVenturesInfo"] = segoVenturesInfo;
    this.componentInfo["segoRealEstateInfo"] = segoRealEstateInfo;
    this.componentInfo["segoCreativeInfo"] = segoCreativeInfo;
    this.infoLineas.push(segoVenturesInfo, segoRealEstateInfo, segoCreativeInfo);

    if (this.plataformaId == 'SEGOFINANCE')
    {
      this.componentInfo["segoFactoringInfo"] = segoFactoringInfo
      this.componentInfo["segoFundsInfo"] = segoFundsInfo
      this.infoLineas.push(segoFactoringInfo, segoFundsInfo);
    }
  }

  private getPlataformaDomain(): void
  {
    const plataformaId = DOMAIN_ENVIRONMENT[this._platformService._domainEnvironment];
    switch (plataformaId)
    {
      case 'VENTURE':
        this.selectedProducto = 'cnmv';
        this.seleccionarLinea('segoVenturesInfo');
        break;
      case 'REALESTATE':
        this.selectedProducto = 'cnmv';
        this.seleccionarLinea('segoRealEstateInfo');
        break;
      case 'CREATIVE':
        this.selectedProducto = 'cnmv';
        this.seleccionarLinea('segoCreativeInfo');
        break;
      case 'FACTORING':
        this.selectedProducto = 'otros';
        this.seleccionarLinea('segoFactoringInfo');
        break;
      case 'FUNDS':
        this.selectedProducto = 'otros';
        this.seleccionarLinea('segoFundsInfo');
        break;
      default:
        this.selectedProducto = 'cnmv';
        this.seleccionarLinea('segoVenturesInfo');
        break;
    }
  }

  seleccionarLinea(linea: string): void
  {
    switch (linea)
    {
      case 'venture':
        linea = "segoVenturesInfo";
        break;
      case 'factoring':
        linea = "segoFactoringInfo";
        break;
      case 'realestate':
        linea = "segoRealEstateInfo";
        break;
      case 'creative':
        linea = "segoCreativeInfo";
        break;
      case 'funds':
        linea = "segoFundsInfo";
        break;
    }
    this.lineaActiva = linea;
    this.infoLineaActiva = this.componentInfo[linea];
  }

  private fixMobilePosition(): void
  {
    if (isPlatformBrowser(this._platformId))
    {
      window.onscroll = function (ev)
      {
        var elementFixed = document.getElementById("position-linea-select");

        if (elementFixed != null)
        {
          if (window.innerWidth < 768)
          {
            if ((window.scrollY <= 620) || (window.scrollY >= 1600))
            {
              elementFixed.classList.add("position-relative");
              elementFixed.classList.remove("position-fixed")
            }
            if (window.scrollY > 620 && (window.scrollY < 1600))
            {
              elementFixed.classList.add("position-fixed")
              elementFixed.classList.remove("position-relative");
            }
          }
        }
      }
    };
  }
}
